export default {
    name: 'fedRegistry',
    serverName: '/api/v1/fed_calculator/',
    fertilizerUrl: '/api/v1/fed_calculator/fed_fertilizer/',
    protocolUrl: '/api/v1/fed_calculator/fed_protocol/',
    calculatorUrl: '/api/v1/fed_calculator/fed_calculator/'
};
